import React from 'react';
import { Navigate } from 'react-router-dom';

import { useAppSelector } from '@/store';
import { resumeStep } from './lib/resume-step';

/**
 * `/account/onboarding` itself: open where the owner's build stands. A setup that is finished (region, name,
 * domain and logo saved) but was never launched resumes on the deploy step and its Finish setup button; anything
 * else starts at the region step. Waits for the session to settle (the wizard root loads it, finding it through
 * `/session/check` when this browser has no id, e.g. a support agent impersonating the owner), so a resumable
 * owner is never sent to step 1 first.
 */
export const CustomizerIndex = (): React.ReactElement | null => {
  const settled = useAppSelector((state) => (state.session.loaded || state.session.error != null) && !state.session.loading);
  const status = useAppSelector((state) => state.session.status);
  const saved = useAppSelector((state) => state.session.data?.customization_data);
  if (!settled) return null;
  return <Navigate to={resumeStep(status, saved)} replace />;
};

export default CustomizerIndex;
